import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";
import { states } from "../../../constants/data";
import { yesNo } from "../../../constants/options";

function Driver({
  fields,
  utilities,
}) {
  const { 
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
  } = utilities;

  return (
    <PageWrapper legendInfo="The Driver">
      <div className={Styles.labelInputContainer}>
        <div className={Styles.groupedInputs}>
          <div className={Styles.labelContainer}>
            <p className={Styles.label}>Who was driving?</p>
          </div>
          {createNoLabelInput(fields.driverFirstName, "100%", Styles.anonInput)}
          {createNoLabelInput(fields.driverLastName, "100%", Styles.anonInput)}
        </div>
        {createToggleInput(fields.whoIsTheInsured, "100%", yesNo, true)}
        {createToggleInput(fields.driverIsInjured, "100%", yesNo, true)}
      </div>

      <div className={Styles.labelInputContainer}></div>
      {!fields.whoIsTheInsured.value && (
             <div className={`${Styles.fadeIn} ${Styles.labelInputContainer}`}>
             <p className={Styles.sectionLabel}>
               <b>Non-Insured Information</b>
             </p>
             <div className={Styles.inputContainer}>
              {createNoLabelInput(fields.whoAddress, "100%", Styles.anonInput)}
              {createNoLabelInput(fields.whoCity, "100%", Styles.anonInput)}
             </div>
             <div className={Styles.inputContainer}>
              {createNoLabelSelect(fields.whoState, "30%", states, Styles.anonSelect, "Select a State")}
              {createNoLabelInput(fields.whoZipcode, "20%", Styles.anonInput)}
              {createNoLabelInput(fields.whoCounty, "50%", Styles.anonInput)}
             </div>
           </div>
      )}
    </PageWrapper>
  );
}

export default Driver;
